import { useParams } from "react-router-dom";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH } from "../constant/reportType";
import { Switch, Table } from "antd";
import { ASSET_TYPE_COLUMN, ASSETS_COLUMN, INVESTMENT_MASTER_COLUMN } from "../constant/AppConstant";
import { BsDownload, BsFillFileEarmarkBarGraphFill, BsPencilSquare, BsPlus, BsSearch } from "react-icons/bs";
import { alertMessage } from "../../utils/AlertService";
import { useAppSelector } from "../../redux-toolkit/hooks";
import Loading from "../Loading";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { getAllcountryDetail } from "../../redux-toolkit/slices/countrySlice";
import { useDeleteInvestmentMasterMutation, useGetAllInvestmentMasterBySearchMutation, useGetAllInvestmentMasterMutation } from "../../redux-toolkit/services/investmentMasterService";
import { getAllInvestmentMasterBySearch, getAllInvestmentMasterDetails, getInvestmentMasterTotalRecords, setAllInvestmentMasterBySearch, setInvestmentMaster } from "../../redux-toolkit/slices/investmentMasterSlice";
import FOInvestmentData from "./FOInvestmentData";
import { formatDate } from "date-fns";
import { useDeleteAssetTypeMutation, useGetAllAssetTypeBySearchMutation, useGetAllAssetTypeMutation } from "../../redux-toolkit/services/assetTypeService";
import { getAllAssetTypeBySearch, getAllAssetTypeDetails, getAssetTypeTotalRecords, setAllAssetTypeBySearch, setAssetType } from "../../redux-toolkit/slices/assetTypeSlice";
import { useDeleteAssetsMutation, useDownloadRiskReportMutation, useGetAllAssetsBySearchMutation, useGetAllAssetsMutation } from "../../redux-toolkit/services/assetsService";
import { getAllAssetsBySearch, getAllAssetsDetails, getAssetsTotalRecords, setAllAssetsBySearch, setAssets } from "../../redux-toolkit/slices/assetsSlice";
import { marked } from "marked";

type Props = {};
const FOInvestment = (props: Props) => {

    const params = useParams();
    const dispatch = useDispatch();
    const localUserObj: any = getLocalStorageData("localUser");
    const token: any = getLocalStorageData("localUser").token;

    //state
    const [actionType, setActionType] = useState(ACTION_TYPE.ADD_ACTION) as any;
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [show, setShow] = useState(false);
    const [selectedRow, setSelectedRow]: any = useState([]);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [call, setCall] = useState("N");
    const [isCategory, setIsCategory] = useState(false);
    const [html, setHtml] = useState("");
    const [recordData, setRecordData]: any = useState("");

    //getMutations
    const [getAllInvestmentMaster, allInvestmentMasterResponse] = useGetAllInvestmentMasterMutation();
    const [getAllAssetType, allAssetTypeResponse] = useGetAllAssetTypeMutation();
    const [getAllAssets, allAssetsResponse] = useGetAllAssetsMutation();

    //search
    const [getAllInvestmentMasterWithSearch, allInvestmentMasterWithSearchResponse] = useGetAllInvestmentMasterBySearchMutation();
    const [getAllAssetTypeWithSearch, allAssetTypeWithSearchResponse] = useGetAllAssetTypeBySearchMutation();
    const [getAllAssetsWithSearch, allAssetsWithSearchResponse] = useGetAllAssetsBySearchMutation();

    //delete mutation
    const [deleteInvestmentMaster, deleteInvestmentMasterResponse] = useDeleteInvestmentMasterMutation();
    const [deleteAssetType, deleteAssetTypeResponse] = useDeleteAssetTypeMutation();
    const [deleteAssets, deleteAssetsResponse] = useDeleteAssetsMutation();

    const [downloadReport, downloadReportResponse] = useDownloadRiskReportMutation();

    //totalRecords
    const totalInvestmentMaster: any = useAppSelector(getInvestmentMasterTotalRecords);
    const totalAssetType: any = useAppSelector(getAssetTypeTotalRecords);
    const totalAssets: any = useAppSelector(getAssetsTotalRecords);

    //selector
    const allCountries: any = useAppSelector(getAllcountryDetail);

    const allInvestmentMaster: any = useAppSelector(getAllInvestmentMasterDetails)
    const allInvestmentMasterBySearch: any = useAppSelector(getAllInvestmentMasterBySearch);
    const allAssetType: any = useAppSelector(getAllAssetTypeDetails);
    const allAssetTypeBySearch: any = useAppSelector(getAllAssetTypeBySearch);
    const allAssets: any = useAppSelector(getAllAssetsDetails);
    const allAssetsBySearch: any = useAppSelector(getAllAssetsBySearch);

    useEffect(() => {
        switch (params.reportType) {
            case REPORT_PATH.INVESTMENT_MASTER:
                setReportName(REPORT_NAME.INVESTMENT_MASTER)
                break;
            case REPORT_PATH.ASSET_TYPE:
                setReportName(REPORT_NAME.ASSET_TYPE)
                break;
            case REPORT_PATH.ASSETS:
                setReportName(REPORT_NAME.ASSETS)
                break;
            default:
        }
    }, [params.reportType]);

    const handleShowReport = (record: any) => {

        const response = JSON.parse(record?.llmResponse);
        const finalContent = response?.choices?.[0]?.message?.content || "";
        const html: any = marked(finalContent);
        setHtml(html);
        setRecordData(record);
    }

    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "name",
            fixed: "right",
            width: 120,
            render: (index: any, record: any) => {
                return (
                    // for delete switch button
                    <div className="d-flex justify-content-between">
                        <div className="px-2 pe-auto">
                            <Switch
                                className={`${record.status === true ||
                                    record.enabled === true ||
                                    record.isActive === true ? "bg-accent" : "bg-secondry"}`}
                                checked={
                                    record.status === true ||
                                        record.enabled === true ||
                                        record.isActive === true
                                        ? true
                                        : false
                                }
                                onClick={() => {
                                    console.log(record, "record")
                                    onDeleteData(record);
                                }}
                            />
                        </div>
                        {record.status === true ||
                            record.enabled === true ||
                            record.isActive === true ? (
                            <div
                                className="px-2 pe-auto"
                                onClick={() => {
                                    handleOpenForm(record);
                                }}
                            >
                                <BsPencilSquare size={18} />
                            </div>
                        ) : null}
                        {/* {reportName === REPORT_NAME.ASSETS && (
                            <div
                                className="px-2 pe-auto"
                                onClick={() => {
                                    handleShowReport(record);
                                }}
                            >
                                <BsFillFileEarmarkBarGraphFill size={18} color="#0078d4" />
                            </div>
                        )} */}
                    </div>
                );
            },
        };

        const tempAction2: any = {
            title: "Reports",
            dataIndex: "reports",
            key: "reports",
            fixed: "right",
            width: 120,
            render: (index: any, record: any) => {
                return (
                    <div className="d-flex justify-content-between">
                        {reportName === REPORT_NAME.ASSETS &&
                            record.llmResponse !== null &&
                            record.llmResponse.trim() !== "" && (
                                <div
                                    className="px-2 pe-auto"
                                    onClick={() => {
                                        handleShowReport(record);
                                    }}
                                >
                                    <BsFillFileEarmarkBarGraphFill size={18} color="#0078d4" />
                                </div>
                            )}
                    </div>
                );
            },
        };


        if (reportName === REPORT_NAME.INVESTMENT_MASTER && INVESTMENT_MASTER_COLUMN) {
            INVESTMENT_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.ASSET_TYPE && ASSET_TYPE_COLUMN) {
            ASSET_TYPE_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.ASSETS && ASSETS_COLUMN) {
            ASSETS_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            temp.push(tempAction2);
            setColumnData(temp);
        }
    }, [reportName, params.reportType]);

    useEffect(() => {
        if (reportName === REPORT_NAME.INVESTMENT_MASTER) {
            getAllInvestmentMaster({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.ASSET_TYPE) {
            getAllAssetType({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.ASSETS) {
            getAllAssets({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        }
    }, [reportName]);

    useEffect(() => {
        if (call === "Y") {
            if (reportName === REPORT_NAME.INVESTMENT_MASTER) {
                getAllInvestmentMaster({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "desc",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.ASSET_TYPE) {
                getAllAssetType({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "desc",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.ASSETS) {
                getAllAssets({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "desc",
                });
                setCall("N");
            }
        }
    }, [call]);

    const paginationChange = (page: number, pageSize: number) => {
        if (reportName === REPORT_NAME.INVESTMENT_MASTER) {
            getAllInvestmentMaster({
                token: localUserObj?.token,
                page: page - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.ASSET_TYPE) {
            getAllAssetType({
                token: localUserObj?.token,
                page: page - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.ASSETS) {
            getAllAssets({
                token: localUserObj?.token,
                page: page - 1,
                size: pageSize,
                sort: "desc",
            });
        }
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleShow = () => {
        setActionType(ACTION_TYPE.ADD_ACTION);
        setShow(true)
    };

    const onDeleteData = (record: any) => {
        if (reportName === REPORT_NAME.INVESTMENT_MASTER) {
            deleteInvestmentMaster({ token: localUserObj?.token, id: record.id });

        } else if (reportName === REPORT_NAME.ASSET_TYPE) {
            deleteAssetType({ token: localUserObj?.token, id: record.id });

        } else if (reportName === REPORT_NAME.ASSETS) {
            deleteAssets({ token: localUserObj?.token, id: record.id });

        }
    };

    useEffect(() => {
        if (deleteInvestmentMasterResponse.isSuccess) {
            if (deleteInvestmentMasterResponse.data?.isActive) {
                alertMessage("Entity Master enable successfully", "success");
            } else {
                alertMessage("Entity Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteInvestmentMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteInvestmentMasterResponse.isSuccess, deleteInvestmentMasterResponse.isError]);

    useEffect(() => {
        if (deleteAssetTypeResponse.isSuccess) {
            if (deleteAssetTypeResponse.data?.isActive) {
                alertMessage("Asset Type enable successfully", "success");
            } else {
                alertMessage("Asset Type deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteAssetTypeResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteAssetTypeResponse.isSuccess, deleteAssetTypeResponse.isError]);

    useEffect(() => {
        if (deleteAssetsResponse.isSuccess) {
            if (deleteAssetsResponse.data?.isActive) {
                alertMessage("Assets enable successfully", "success");
            } else {
                alertMessage("Assets deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteAssetsResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteAssetsResponse.isSuccess, deleteAssetsResponse.isError]);

    const handleOpenForm = (record: any) => {
        setActionType(ACTION_TYPE.UPDATE_ACTION);
        setSelectedRow(record);
        setShow(true);
    };

    useEffect(() => {
        if (allInvestmentMasterResponse.isSuccess) {
            dispatch(setInvestmentMaster(allInvestmentMasterResponse));
        } else if (allInvestmentMasterResponse.isError) {
            let response: any = allInvestmentMasterResponse.error;
            alertMessage(response, "error");
        }

    }, [allInvestmentMasterResponse.isSuccess, allInvestmentMasterResponse.isError]);

    useEffect(() => {
        if (allAssetTypeResponse.isSuccess) {
            dispatch(setAssetType(allAssetTypeResponse));
        } else if (allAssetTypeResponse.isError) {
            let response: any = allAssetTypeResponse.error;
            alertMessage(response, "error");
        }

    }, [allAssetTypeResponse.isSuccess, allAssetTypeResponse.isError]);

    useEffect(() => {
        if (allAssetsResponse.isSuccess) {
            dispatch(setAssets(allAssetsResponse));
        } else if (allAssetsResponse.isError) {
            let response: any = allAssetsResponse.error;
            alertMessage(response, "error");
        }

    }, [allAssetsResponse.isSuccess, allAssetsResponse.isError]);

    const buildInvestmentMaster = (data: any) => {
        let temp: any = [];

        data.forEach((element: any) => {
            const country = allCountries?.find((c: any) => c.id === element.countryId);
            // let payload =
            temp.push({
                id: element.id,
                actualROI: element?.actualROI,
                amount: element?.amount,
                assetType: element?.assetType ? element?.assetType.name : "-",
                expROI: element?.expROI,
                mandate: element?.mandate ? element.mandate.name : "-",
                familyOffice: element?.familyOfficeMaster ? element.familyOfficeMaster.name : "-",
                name: element?.name,
                code: element?.code,
                startDate: element?.startDate ? formatDate(element.startDate, 'MM/dd/yyyy') : "-",
                status: element?.status,
            });
        });
        setDatasource(temp);
    };


    const buildAssets = (data: any) => {
        let temp: any = [];

        data.forEach((element: any) => {
            const country = allCountries?.find((c: any) => c.id === element.countryId);
            // let payload =
            temp.push({
                id: element.id,
                name: element?.name,
                code: element?.code,
                assetType: element?.assetType ? element?.assetType.name : "-",
                initialValue: element?.initialValue,
                current: element?.current,
                familyOffice: element?.familyOfficeMaster ? element.familyOfficeMaster.name : "-",
                date: element?.date ? formatDate(element.date, 'yyyy-MM-dd') : "-",
                llmResponse: element?.llmResponse ? element?.llmResponse : "",
                status: element?.status,
            });
        });
        setDatasource(temp);
    };

    //data

    useEffect(() => {
        if (allInvestmentMaster && reportName === REPORT_NAME.INVESTMENT_MASTER) {
            buildInvestmentMaster(allInvestmentMaster);
        }
    }, [allInvestmentMaster]);

    useEffect(() => {
        if (allAssetType && reportName === REPORT_NAME.ASSET_TYPE) {
            setDatasource(allAssetType);
        }
    }, [allAssetType]);

    useEffect(() => {
        if (allAssets && reportName === REPORT_NAME.ASSETS) {
            buildAssets(allAssets);
        }
    }, [allAssets]);

    const handleSearch = (event: any) => {
        if (reportName === REPORT_NAME.INVESTMENT_MASTER) {
            getAllInvestmentMasterWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.ASSET_TYPE) {
            getAllAssetTypeWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.ASSETS) {
            getAllAssetsWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        }
    };

    useEffect(() => {
        if (allInvestmentMasterWithSearchResponse.isSuccess) {
            dispatch(setAllInvestmentMasterBySearch(allInvestmentMasterWithSearchResponse));
        } else if (allInvestmentMasterWithSearchResponse.isError) {
            let response: any = allInvestmentMasterWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [allInvestmentMasterWithSearchResponse.isSuccess, allInvestmentMasterWithSearchResponse.isError]);

    useEffect(() => {
        if (allAssetTypeWithSearchResponse.isSuccess) {
            dispatch(setAllAssetTypeBySearch(allAssetTypeWithSearchResponse));
        } else if (allAssetTypeWithSearchResponse.isError) {
            let response: any = allAssetTypeWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [allAssetTypeWithSearchResponse.isSuccess, allAssetTypeWithSearchResponse.isError]);

    useEffect(() => {
        if (allAssetsWithSearchResponse.isSuccess) {
            dispatch(setAllAssetsBySearch(allAssetsWithSearchResponse));
        } else if (allAssetsWithSearchResponse.isError) {
            let response: any = allAssetsWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [allAssetsWithSearchResponse.isSuccess, allAssetsWithSearchResponse.isError]);

    useEffect(() => {
        if (allInvestmentMasterBySearch && reportName === REPORT_NAME.INVESTMENT_MASTER) {
            buildInvestmentMaster(allInvestmentMasterBySearch);
        }
    }, [allInvestmentMasterBySearch]);

    useEffect(() => {
        if (allAssetTypeBySearch && reportName === REPORT_NAME.ASSET_TYPE) {
            setDatasource(allAssetTypeBySearch);
        }
    }, [allAssetTypeBySearch]);

    useEffect(() => {
        if (allAssetsBySearch && reportName === REPORT_NAME.ASSETS) {
            buildAssets(allAssetsBySearch);
        }
    }, [allAssetsBySearch]);

    const handleDownloadRreport = () => {
        if (reportName === REPORT_NAME.ASSETS) {
            // recordData
            const tableData = [
                {
                    code: recordData.code,
                    name: recordData.name,
                    assetType: recordData.assetType,
                    initialValue: recordData.initialValue,
                    current: recordData.current,
                    date: recordData.date,
                    familyOffice: recordData.familyOffice,
                }
            ]

            const response = JSON.parse(recordData?.llmResponse);
            const finalContent = response?.choices?.[0]?.message?.content || "";

            const payload = {
                tableData: tableData,     // array of RowData
                llmResponse: finalContent         // HTML string from LLM
            };

            downloadReport({
                token: localUserObj?.token,
                payload
            })
                .unwrap()
                .then((blob: any) => {
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = "Asset_Report.pdf";
                    link.click();
                    window.URL.revokeObjectURL(url);

                    alertMessage("Report downloaded successfully", "success");
                })
                .catch((error: any) => {
                    alertMessage("Error while downloading", "error");
                });
        }
    }

    return (
        <div className="mt-2 overflow-y-auto">
            <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
                <div className="d-flex align-items-center w-100 px-2">
                    <h5
                        className="m-0 px-0 d-flex align-items-center text-accent"
                        style={{ fontWeight: "700" }}
                    >
                        {reportName}
                    </h5>
                </div>
                <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100">
                    <div className="d-flex flex-column">
                        <div className="input-group px-2 mt-1">
                            <Form.Control
                                type="search"
                                placeholder="Search"
                                className="border-0 bg-cm-light-primary1"
                                aria-label="Search"
                                onChange={handleSearch}
                            />
                            <div className="input-group-append bg-cm-light-primary1 p-1 rounded-end">
                                <span className="input-group-text bg-cm-light-primary1 border-0">
                                    {/* <img src={gear} alt="" /> */}
                                    <BsSearch className=" bg-cm-light-primary1 border-cm-light-primary1" />
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex px-2 align-items-center mt-1">
                        <Button
                            // variant="primary"
                            className="d-flex align-items-center me-0 text-nowrap bg-accent"
                            onClick={handleShow}
                        >
                            <BsPlus />
                            Add
                        </Button>
                    </div>
                    {allInvestmentMasterResponse.isLoading ||
                        allAssetTypeResponse.isLoading ||

                        allInvestmentMasterWithSearchResponse.isLoading ||
                        allAssetTypeWithSearchResponse.isLoading ||

                        deleteInvestmentMasterResponse.isLoading ||
                        deleteAssetTypeResponse.isLoading ||
                        downloadReportResponse.isLoading
                        ? (
                            <Loading />
                        ) : (
                            ""
                        )}
                    {show && (
                        <FOInvestmentData
                            show={show}
                            setShow={setShow}
                            actionType={actionType}
                            reportName={reportName}
                            data={selectedRow}
                            setCall={setCall}
                            isCategory={isCategory}
                            setIsCategory={setIsCategory}
                        />
                    )}
                </div>
            </div>
            <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                <Table
                    bordered={true}
                    rowKey={"id"}
                    scroll={{ x: 'max-content' }}
                    tableLayout="fixed"
                    pagination={{
                        total: (() => {
                            switch (reportName) {
                                case REPORT_NAME.INVESTMENT_MASTER:
                                    return totalInvestmentMaster;
                                case REPORT_NAME.ASSET_TYPE:
                                    return totalAssetType;
                                default:
                                    return dataSource.length;
                            }
                        })(),
                        responsive: true,
                        current: currentpage,
                        // showSizeChanger: true,  
                        pageSizeOptions: [10, 20, 30],
                        onChange: (page, pageSize) => {
                            paginationChange(page, pageSize);
                        },
                        pageSize: pageSize,
                    }}
                    columns={columData}
                    dataSource={dataSource}
                />
            </div>
            {html && (
                <div>
                    <div className="d-flex justify-content-end">
                        <Button
                            // variant="primary"
                            className="d-flex align-items-center me-0 text-nowrap bg-accent"
                            onClick={handleDownloadRreport}
                        >
                            <BsDownload className="me-1" />
                            Download Report
                        </Button>
                    </div>
                    <div style={{
                        border: "2px solid #ddd",
                        padding: "16px",
                        borderRadius: "8px",
                        marginTop: "20px",
                        textAlign: "left"
                    }}>
                        <h2>Risk Assessment Report</h2>
                        <div
                            className="mt-5"
                            dangerouslySetInnerHTML={{ __html: html }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
export default FOInvestment;